export default class SingletonBootConfig {
  static instance;
  constructor() {
    this.config = window["boot"];
  }

  static getInstance() { 
    if (SingletonBootConfig.instance) {
      return SingletonBootConfig.instance;
    }
    SingletonBootConfig.instance = new SingletonBootConfig();
    return SingletonBootConfig.instance;
  }

  getConfig = () => {
    return this.config;
  };

  getExternalChat = () => {
    return this.config.remoteWS.concat(this.config.externalChat);
  };

  getChatWS = () => {
    return this.config.remoteWS.concat(this.config.chatWS);
  };
}
